import { FunctionComponent, ReactNode, SVGProps } from 'react'
import clsx from 'clsx'

import { AlertMessageType } from 'lib/enums/alertMessages'

const BGCOLORS: { [key: string]: string } = {
  error: 'bg-yellow-50',
  success: 'bg-success',
}

export function Alert({
  className = 'bg-brand-900',
  icon: Icon = '⚠️',
  children,
  ...props
}: AlertProps) {
  return (
    <div
      className={clsx(
        'rounded-lg',
        'whitespace-nowrap truncate',
        'space-x-4 px-4 py-3.5',
        'flex items-center',
        'text-tiny',
        className
      )}
      {...props}>
      <span aria-hidden='true'>
        {typeof Icon === 'string' ? Icon : <Icon />}
      </span>
      <span role='alert'>{children}</span>
    </div>
  )
}

function AlertGroup({ alert, className }: AlertGroupProps) {
  return alert ? (
    <Alert
      className={clsx(BGCOLORS[alert.status], className)}
      icon={alert.icon}>
      <p>{alert.message}</p>
    </Alert>
  ) : null
}

interface AlertProps {
  className?: string
  icon?: string | FunctionComponent<SVGProps<SVGSVGElement>>
  children: ReactNode
}

interface AlertGroupProps {
  alert: AlertMessageType
  className?: string
}

export default AlertGroup
